<template>
  <div id="app" class="h-100" :class="[skinClasses]">
    <component :is="layout">
      <router-view />
    </component>

    <scroll-to-top v-if="enableScrollToTop" />
  </div>
</template>

<script>
import ScrollToTop from '@core/components/scroll-to-top/ScrollToTop.vue'

// This will be populated in `beforeCreate` hook
import { $themeColors, $themeBreakpoints, $themeConfig } from '@themeConfig'
import { provideToast } from 'vue-toastification/composition'
import { onMounted, onUnmounted, watch } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'

import { useWindowSize, useCssVar } from '@vueuse/core'

import store from '@/store'
import SocketClient from './services/websocket'
import useJwt from '@/auth/jwt/useJwt'
import { F } from 'caniuse-lite/data/agents'

import { eventBus } from "./main";

const LayoutVertical = () => import('@/layouts/vertical/LayoutVertical.vue')
const LayoutFull = () => import('@/layouts/full/LayoutFull.vue')

export default {
  components: {

    // Layouts
    LayoutVertical,
    LayoutFull,

    ScrollToTop,
  },
  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  computed: {
    layout() {
      if (this.$route.meta.layout === 'full') return 'layout-full'
      return `layout-${this.contentLayoutType}`
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type
    },
  },
  beforeCreate() {
    // Set colors in theme
    const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(`--${colors[i]}`, document.documentElement).value.trim()
    }

    // Set Theme Breakpoints
    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(useCssVar(`--breakpoint-${breakpoints[i]}`, document.documentElement).value.slice(0, -2))
    }

    // Set RTL
    const isRTL  = store.getters['auth/preferDirIsRtl'] || $themeConfig.layout.isRTL
    //const isRTL =true;

    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr')

    // Set lang
    this.$i18n.locale = store.getters['auth/getPreferLang']





  },
  setup() {

    const { skin, skinClasses } = useAppConfig()
    const { enableScrollToTop } = $themeConfig.layout



    onMounted(() => {
      SocketClient.connect()
      document.addEventListener('visibilitychange', function (event) {
        if (document.hidden) store.state.ws.instance.send("stop send new notification")
        else store.state.ws.instance.send("send new notification")
      })
      // here rest app  dirction when come back   from  map
      window.addEventListener('popstate', function(event) {
        var path = window.location.pathname;
        var page = path.split("/").pop();
        let storeDirection = store.state.auth.userData.settings.lang === 'ar' ? 'rtl' : 'ltr'

        if(page =='live' || page == 'history'){
          document.getElementsByTagName('html')[0].dir = 'ltr';
        }else{
          document.getElementsByTagName('html')[0].dir = storeDirection;
        }

     });
    })

    // If skin is dark when initialized => Add class to body
   // if (skin.value === 'dark') document.body.classList.add('dark-layout')
 if (store.getters['auth/isPreferSkinDark']=='dark') document.body.classList.add('dark-layout')
    // Provide toast for Composition API usage
    // This for those apps/components which uses composition API
    // Demos will still use Options API for ease
    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 3000,
      transition: 'Vue-Toastification__fade',
    })

    // Set Window Width in store
    store.commit('app/UPDATE_WINDOW_WIDTH', window.innerWidth)
    const { width: windowWidth } = useWindowSize()
    watch(windowWidth, val => {
      store.commit('app/UPDATE_WINDOW_WIDTH', val)
    })

    return {
      skinClasses,
      enableScrollToTop,
    }
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@300&display=swap');
</style>
